import { __rest, __assign } from '../../node_modules/tslib/tslib.es6.js';
import React, { forwardRef } from 'react';
import { useTheme, IconButton } from '@primer/react';
import { ColorSchemes } from '../../utils/constants.js';

var LTIconButton = /*#__PURE__*/forwardRef(function (_a, ref) {
  var _b, _c;
  var _d = _a.ariaLabel,
    ariaLabel = _d === void 0 ? undefined : _d,
    _e = _a.className,
    className = _e === void 0 ? "" : _e,
    _f = _a.customStyle,
    customStyle = _f === void 0 ? {} : _f,
    _g = _a.disabled,
    disabled = _g === void 0 ? false : _g,
    _h = _a.icon,
    icon = _h === void 0 ? "" : _h,
    _j = _a.onClick,
    onClick = _j === void 0 ? function () {} : _j,
    _k = _a.size,
    size = _k === void 0 ? LTIconButton.Size.MEDIUM : _k,
    _l = _a.variant,
    variant = _l === void 0 ? LTIconButton.IconButtonVariants.DEFAULT : _l,
    rest = __rest(_a, ["ariaLabel", "className", "customStyle", "disabled", "icon", "onClick", "size", "variant"]);
  var colorScheme = useTheme().colorScheme;
  var DisabledBgColor = (_b = {}, _b[LTIconButton.IconButtonVariants.INVISIBLE] = "#EAEEF2B2", _b);
  var DisabledBorderColorStyle = (_c = {}, _c[LTIconButton.IconButtonVariants.DEFAULT] = "#EAEEF2B2", _c[LTIconButton.IconButtonVariants.DANGER] = "#1F23280A", _c[LTIconButton.IconButtonVariants.PRIMARY] = "#95D8A6", _c);
  return /*#__PURE__*/React.createElement(IconButton, __assign({
    "aria-label": ariaLabel,
    className: className,
    icon: icon,
    onClick: onClick,
    size: size,
    ref: ref,
    disabled: disabled,
    sx: __assign(__assign({}, colorScheme !== ColorSchemes.DARK && {
      "&:disabled": {
        borderColor: DisabledBorderColorStyle[variant] || "",
        backgroundColor: DisabledBgColor[variant] || ""
      }
    }), customStyle),
    variant: variant
  }, rest));
});
// Assign static properties for variants and sizes
LTIconButton.IconButtonVariants = {
  DEFAULT: "default",
  PRIMARY: "primary",
  DANGER: "danger",
  OUTLINE: "outline",
  INVISIBLE: "invisible"
};
LTIconButton.Size = {
  LARGE: "large",
  MEDIUM: "medium",
  SMALL: "small"
};

export { LTIconButton as default };
